import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Rendert children direkt an document.body (oder einen anderen container),
 * um Stacking-Context-Probleme mit Sheets/Modals zu umgehen.
 */
export function Portal({ children, container }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); return () => setMounted(false); }, []);
  if (!mounted) return null;
  return createPortal(children, container ?? document.body);
}
